import * as React from 'react';

const VisaPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={36} height={32} viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#visa-payment-rebranding_svg__clip0_101_1056)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M94.296 41.385l-9.702 45.352H72.862l9.704-45.352h11.73zm49.358 29.284l6.177-17.031 3.554 17.03h-9.731zm13.09 16.068h10.851l-9.469-45.352H148.11c-2.251 0-4.15 1.31-4.995 3.328l-17.601 42.024h12.32l2.446-6.773h15.051l1.413 6.773zm-30.619-14.808c.051-11.97-16.553-12.629-16.438-17.975.035-1.63 1.586-3.358 4.975-3.801 1.684-.22 6.313-.388 11.57 2.03l2.058-9.616c-2.824-1.025-6.456-2.011-10.975-2.011-11.595 0-19.757 6.165-19.826 14.992-.073 6.529 5.827 10.172 10.272 12.342 4.57 2.223 6.106 3.647 6.086 5.635-.03 3.045-3.646 4.385-7.019 4.438-5.9.094-9.323-1.591-12.052-2.863l-2.126 9.937c2.74 1.259 7.8 2.353 13.05 2.409 12.323 0 20.385-6.09 20.425-15.517zM77.531 41.385L58.524 86.737H46.121l-9.353-36.194c-.569-2.229-1.062-3.044-2.79-3.984-2.817-1.53-7.475-2.966-11.573-3.856l.28-1.318h19.962c2.544 0 4.833 1.694 5.41 4.624l4.94 26.245 12.209-30.869H77.53z"
                fill="#1434CB"
            />
        </g>
        <defs>
            <clipPath id="visa-payment-rebranding_svg__clip0_101_1056">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

VisaPaymentRebrandingSvg.displayName = 'VisaPaymentRebrandingSvg';
export default VisaPaymentRebrandingSvg;
